// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
   display: block;
   height: 100%;
}

:host ::ng-deep .mat-tab-group {
   height: 100%;
}

:host ::ng-deep .mat-tab-header {
   position: sticky;
   top: 0;
   z-index: 20;
   background: #fff;
}

::ng-deep .mat-tab-label {
   min-width: 5px !important;
}

@media screen and (max-width: 600px) {
   .mat-tab-label {
      min-width: 5px !important;
   }
}

.firstSampleAnimation.ng-hide-add,
.firstSampleAnimation.ng-hide-remove {
   opacity: 1;
}

.firstSampleAnimation.ng-hide {
   z-index: 1;
   opacity: 0;
}

::ng-deep .mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination {
   display: none !important;
}

/deep/ .mat-tab-label-container {
   display: block !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-off/left-panel/left-panel.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,YAAY;AACf;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,MAAM;GACN,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG;MACG,yBAAyB;GAC5B;AACH;;AAEA;;GAEG,UAAU;AACb;;AAEA;GACG,UAAU;GACV,UAAU;AACb;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,yBAAyB;AAC5B","sourcesContent":[":host {\n   display: block;\n   height: 100%;\n}\n\n:host ::ng-deep .mat-tab-group {\n   height: 100%;\n}\n\n:host ::ng-deep .mat-tab-header {\n   position: sticky;\n   top: 0;\n   z-index: 20;\n   background: #fff;\n}\n\n::ng-deep .mat-tab-label {\n   min-width: 5px !important;\n}\n\n@media screen and (max-width: 600px) {\n   .mat-tab-label {\n      min-width: 5px !important;\n   }\n}\n\n.firstSampleAnimation.ng-hide-add,\n.firstSampleAnimation.ng-hide-remove {\n   opacity: 1;\n}\n\n.firstSampleAnimation.ng-hide {\n   z-index: 1;\n   opacity: 0;\n}\n\n::ng-deep .mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination {\n   display: none !important;\n}\n\n/deep/ .mat-tab-label-container {\n   display: block !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
